import React, { Fragment, useEffect, useState } from "react";
import { ReactComponent as SearchIcon } from "assets/images/common/svgs/search.svg";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import { ReactComponent as EyeIcon } from "assets/images/common/svgs/eyeIconTable.svg";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import { UserDTO } from "utils/helpers/models/users/user.dto";
import useUsers from "containers/user-management/useHooks";
import { useSelector } from "react-redux";
import { AllRequestFiltersDTO, UserFiltersDTO } from "utils/helpers/models/common/user-filters.dto";
import { useDebounce } from "hooks/useDebounce";
import { ROLES } from "utils/helpers/enums/roles.enum";
import DataNotFound from "components/particles/table/data-not-found";
import Pagination from "components/particles/table/pagination";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { SESSION_TYPES } from "utils/helpers/enums/shared.enum";
type Tab = {
  id: string;
  label: string;
};



const AllRequests: React.FC = () => {
  const tabs = [
    { title: "Initial Submissions", value: SESSION_TYPES.ALL },
    { title: "Welcome Session", value: SESSION_TYPES.INTRO },
    { title: "Training Session", value: SESSION_TYPES.TRAINING },
    { title: "Dismissed", value: true },

  ];

  const navigate = useNavigate();
  const [data, setData] = useState<UserDTO[]>([]);
  const { getTeamRequests } = useUsers();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [filters, setFilters] = useState<AllRequestFiltersDTO>(new AllRequestFiltersDTO());
  const [totalElements, setTotalElements] = useState<number>(0);
  const debounceSearch = useDebounce(filters.nameOrEmail, 1000);


  const columns: string[] = [
    "Profile",
    "First Name",
    "Last Name",
    "Email",
    "City",
    "Action",
  ];


  const onPageChange = (pageInfo: { selected: number; limit: number }) => {
    const { selected: page, limit } = pageInfo;
    filters.size = limit;
    filters.page = page + 1;
    setFilters({ ...filters });
    getRequests(filters);
  };

  const getRequests = (filters: AllRequestFiltersDTO) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (filters[key]) filtersToSend[key] = filters[key];
    }
    const queryParams = {
      ...filtersToSend,
      page: filters.page - 1,
      rejectedRequest: filters.rejectedRequest,
    };
    getTeamRequests(setData, queryParams, setFilters, setTotalElements);
  };

  useEffect(() => {
    getRequests(filters);
  }, [debounceSearch]);

  const handleChangeFilter = (event: any) => {
    const {
      target: { name, value },
    } = event;
    setFilters({ ...filters, [name]: value });
    if (name === "nameOrEmail" && value === "") {
      getRequests(filters);
    }
  };

  const resetFilters = () => {
    const model = new AllRequestFiltersDTO();
    for (let key in model) {
      filters[key] = model[key];
    }

    setFilters({ ...filters });
    getRequests(filters);
  };

  const handleSearch = (event: any) => {
    const { key } = event;
    if (key === "Enter") {
      getRequests(filters);
    }
  };

  const handleTabChange = (statusValue: string | boolean) => {
    let updatedFilters: any = { ...filters, page: 1 };

    if (statusValue === true) {
      // Dismissed tab clicked
      updatedFilters.rejectedRequest = true;
      updatedFilters.sessionType = undefined;
    } else {
      updatedFilters.sessionType = statusValue;
      updatedFilters.rejectedRequest = false;
    }

    setFilters(updatedFilters);
    getRequests(updatedFilters);
  };

  const goToBack = () => {
    navigate(-1);
  };

  const goToDetail = (userId: number) => {
    navigate(siteRoutes.requestDetail, {
      state: { allData: data, selectedUserId: userId },
    });
  };


  return (
    <div className="">
      <h1 className="text-base text-primaryText font-bold  flex items-center gap-3">
        <span
          onClick={goToBack}
          className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
        >
          <ArrowBackIcon />
        </span>
        All Requests
      </h1>
      <div className="flex flex-wrap justify-between items-center gap-5 my-6 ">
        {/* Tab Navigation */}
        <div className="flex flex-wrap items-center gap-3 justify-start">
          {tabs.map((item: any) => (
            <button
              key={item.value}
              type="button"
              className={`px-4 py-2 text-xs rounded-md transition-colors duration-300 ${(item.value === true && filters.rejectedRequest === true) ||
                (item.value !== true && filters.sessionType === item.value)
                ? "bg-vibrantBlueBg text-white"
                : "bg-warmOffWhiteBg text-mediumGrayText font-bold"
                }`}
              onClick={() => handleTabChange(item.value)}
            >
              {item.title}
            </button>
          ))}
        </div>
        <div className="w-full sm:w-[388px] relative">
          <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-primaryText text-lg" />
          <input
            type="search"
            placeholder="Search by Name or Email"
            value={filters.nameOrEmail}
            onChange={handleChangeFilter}
            onKeyUp={handleSearch}
            name="nameOrEmail"
            className="w-full search-input pl-10 p-2 border-[0.6px] border-borderLightGray rounded-full focus:outline-none bg-coolLightGrayBg"
          />
        </div>
      </div>

      <div className="bg-white rounded-t-lg  border border-mediumGrayBorder overflow-x-auto">
        <table className="min-w-full divide-y divide-mediumGrayBorder">
          {/* Table Header */}
          <thead className="bg-white">
            <tr className="text-left">
              {columns.map((column, index) => {
                return (
                  <th
                    className="px-4 py-4 text-sm font-bold text-left text-primaryText whitespace-nowrap"
                    key={index}
                  >
                    {column}
                  </th>
                );
              })}
            </tr>
          </thead>

          {/* Table Body */}
          <tbody className="bg-white divide-y divide-mediumGrayBorder">
            {data.map((user: any, index: number) => (
              <tr key={index} className="hover:bg-gray-50 ">
                <td className="px-4 py-4">
                  <img
                    className="rounded-full w-9 h-9 object-cover"
                    src={
                      user?.profilePic
                        ? concatPathWithBackendUrl(
                          user?.profilePic?.name
                        )
                        : editProfilePicUser
                    }
                  />
                </td>
                <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                  {user.firstName}
                </td>
                <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                  {user.lastName}
                </td>
                <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                  {user.email}
                </td>
                <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                  {user.city}
                </td>

                <td className="px-4 py-4 text-left whitespace-nowrap w-[124px]">
                  <div className="flex justify-start gap-2 ">
                    {/* Action Buttons */}
                    <button
                      onClick={() => goToDetail(user.id)}
                      className=""
                    >
                      <EyeIcon />
                    </button>


                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Fragment>
        <DataNotFound show={!isLoading && !data.length} />
        <Pagination
          count={totalElements}
          page={filters.page}
          limit={filters.limit}
          onPageChange={onPageChange}
        />
      </Fragment>
    </div>
  );
};

export default AllRequests;
